import { images } from "../constants";

const testimonials = [  
    { 
        id: 1,
        image: images.testimonial1, 
        name: 'Emily Carter', 
        title: 'COO, FutureTechSol',
        content: 'The custom AI solution developed by InnovateAI has streamlined our workflows and enhanced decision-making across departments.'
    }, 
    { 
        id: 2,
        image: images.testimonial2, 
        name: 'Liam Adams', 
        title: 'Market Lead, GenAnalytic',
        content: 'The predictive analytics tools provided by this team have enabled us to anticipate customer needs and stay ahead of market trends.'
    },
    { 
        id: 3,
        image: images.testimonial3, 
        name: 'Sophia Brown', 
        title: 'CTO, Digital Horizon',
        content: 'Thanks to the automated IT solutions, our team has more time to focus on creative tasks rather than repetitive ones. The ROI speaks for itself!'
    },    
    { 
        id: 4,
        image: images.testimonial4, 
        name: 'Oliver White', 
        title: 'Founder, EngageAI',
        content: 'InnovateAI delivered an AI CRM platform that has transformed how we engage with clients. The level of personalization is amazing.'
    },
];

export default testimonials;